var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#icon-edge-2a5df';
                    var viewUrl = 'svg-sprite-4517b925566e061f1603b3f020ad82d5.svg#view-icon-edge-2a5df';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 64 64',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };